import React, { useState } from 'react';
import { Select, Icon, Rate } from 'antd';
import ReactGA from "react-ga4";
import { UserRatingType, RatingSortOption } from '../../models/enums';
import { formatAverageRating, roundToHalf } from '../../utils/ratingHelpers';
import { RatingsInfoModal } from '../RatingsInfoModal/RatingsInfoModal';
import styles from './ratingsFilters.scss';
import Skeleton from "../../components/Skeleton";

interface RatingsFiltersProps {
  filterType: number | null;
  onFilterTypeChange: (value: number | null) => void;
  sortOption?: number;
  onSortChange?: (value: number) => void;
  averageRating?: number | null;
  totalCount?: number;
  loading: boolean
}

const RatingsFilters: React.FC<RatingsFiltersProps> = ({
  filterType,
  onFilterTypeChange,
  sortOption = RatingSortOption.Newest,
  onSortChange,
  averageRating,
  totalCount = 0,
  loading
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleInfoClick = () => {
    ReactGA.event({
      category: "Ocjene",
      action: "Click",
      label: "Tooltip za više info"
    });
    setModalVisible(true);
  };

  const hasRatings = averageRating != null && totalCount > 0;

  const getRatingCountText = (count: number) => {
    if (count === 1) return '1 ocjena';
    if (count >= 2 && count <= 4) return `${count} ocjene`;
    return `${count} ocjena`;
  };

  const displayRating = hasRatings ? roundToHalf(averageRating) : 0;

  if (loading) {
    return (
      <div className={styles.filtersContainer}>
        <div className={styles.loadingSkeleton}>
          <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
            <Skeleton style={{ width: 136, margin: 0, height: 30 }} />
            <Skeleton style={{ width: 137, margin: 0, height: 23 }} />
            <Skeleton style={{ width: 137, margin: 0, height: 23 }} />
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <Skeleton style={{ width: 200, margin: 0, height: 54 }} />
            <Skeleton style={{ width: 170, margin: 0, height: 54 }} />

          </div>
        </div>
      </div>

    )
  }

  return (
    <div className={styles.filtersContainer}>
      <div className={styles.titleRow}>
        <div className={styles.ratingsSummary}>
          <Rate disabled value={displayRating} allowHalf className={styles.summaryStars} />
          {hasRatings ? (
            <React.Fragment>
              <span className={styles.ratingValue}>{formatAverageRating(averageRating)}</span>
              <span className={styles.ratingCount}>({getRatingCountText(totalCount)})</span>
            </React.Fragment>
          ) : (
            <span className={styles.noRatings}>nema ocjena</span>
          )}
          <span className={styles.moreInfoLink} onClick={handleInfoClick}>
            <Icon type="info-circle" /><span className={styles.moreInfoText}> Više informacija</span>
          </span>
        </div>
        <div className={styles.filtersRow}>
          <Select
            className={styles.filterSelect}
            value={filterType}
            onChange={value => onFilterTypeChange(value)}
            dropdownMatchSelectWidth={false}
            placeholder="Prikaz svih ocjena"
          >
            <Select.Option value={null}>Prikaz svih ocjena</Select.Option>
            <Select.Option value={UserRatingType.buyerRating}>Ocjene kao kupac</Select.Option>
            <Select.Option value={UserRatingType.sellerRating}>Ocjene kao prodavač</Select.Option>
          </Select>
          <Select
            className={styles.sortSelect}
            value={sortOption}
            onChange={value => onSortChange && onSortChange(value)}
            dropdownMatchSelectWidth={false}
          >
            <Select.Option value={RatingSortOption.Newest}>Prvo najnovije</Select.Option>
            <Select.Option value={RatingSortOption.Oldest}>Prvo najstarije</Select.Option>
            <Select.Option value={RatingSortOption.Highest}>Najviša ocjena</Select.Option>
            <Select.Option value={RatingSortOption.Lowest}>Najniža ocjena</Select.Option>
          </Select>
        </div>
      </div>
      <RatingsInfoModal visible={modalVisible} onCancel={() => setModalVisible(false)} />
    </div>
  );
};

export default RatingsFilters;



// WEBPACK FOOTER //
// ./src/components/RatingsFilters/index.tsx